/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createRelationalNode } from '../../factoriesAny.js';
export var RelationalNodeDependencies = {
  NodeDependencies,
  createRelationalNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesRelationalNode.generated.js
// module id = LfG8
// module chunks = 3